<template>
  <details :id="uID" class="dtt-select">
    <summary class="radios" :class="{addLabel : label, addDesc : description}">
      <p class="select-label">{{label}}</p>
 
      <span v-if="selectedItem.length !== 0 && canClear" class="fal fa-times-circle clear-icon" @click="clearAll"></span>
 
      <!-- Placeholder -->
      <p v-if="selectedItem.length === 0" class="__placeholder">{{ placeholder}}</p>
 
      <!-- Multiple Tags -->
      <div v-else class="select-field" @click="hideList">
        <div v-for="(selected, index) in selectedItem" :key="index" class="select-tag">
          <slot name="input" v-bind:item="selected">
            {{
              value ?
              selected[`${labelField}`] :
              placeholder
            }}
          </slot>
          <span class="fal fa-times remove-option" @click="removeItem(index)"></span>
        </div>
      </div>
 
      <p class="select-description">{{description}}</p>
    </summary>
 
   
    <div class="list">
      <!-- Search Field -->
      <div v-if="options.length !== 0 && !hideSearch" class="search-field">
        <input v-model="search" placeholder="Search" class="search-bar"/>
        <span class="fal fa-search search-icon"></span>
      </div>
 
      <!-- No Items Placeholder -->
      <p v-if="options.length === 0" class="__no-records">
        <slot name="no-options">No records found</slot>
      </p>
 
      <!-- Items Placeholder -->
      <div class="item-list" ref="itemDropdown" :style="adjustHeight">
        <div v-for="(option, index) in filteredList" :key="index" class="__item" @click="selectItem(option)" ref="item">
          <slot name="option" v-bind:item="option">{{ option.text }}</slot>
          <span v-if="checkItem(option, index)" class="fal fa-check selected-indicator"></span>
        </div>
      </div>
    </div>
  </details>
</template>
 
<script>
import _ from "lodash"
 
export default {
  props: {
    id: {
      type: String,
    },
    placeholder: {
      type: String,
      default: 'Select'
    },
    label: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: 'Allow multiple entries'
    },
    options: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array
    },
    max:{
      type: String,
      default: '10'
    },
    labelField: {
      type: String,
      default: 'text'
    },
    canClear: {
      type: Boolean,
      default: false
    },
    hideSearch: {
      type: Boolean,
      default: false
    },
  },
 
  data () {
    return {
      selectedItem: [],
      height: 'max-content',
      itemCount: 0,
      search: ''
    }
  },
 
  computed: {
    uID () {
      if (this.id) {
        return this.id
      } else {
        return 'dtt-select' + this.createUID()
      }
    },
 
    filteredList() {
      //Searches through all array keys
      return this.options.filter(item =>
        Object.keys(item).some((key) => {
          return String(item[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
      )
    },
   
    adjustHeight() {
      return {
        "max-height": `${this.height}`,
      }
    }
  },
 
  mounted(){
    this.loadTags()
   
    //Adjust the dropdown height to display 10 items only
    if(this.itemCount == this.max){
      this.height = (this.$refs.item[0].clientHeight*this.max)+"px"
    }
  },
 
  methods: {
    loadTags(){
      if (this.value){
        // Load tags if there is external data
        this.selectedItem = Array.from(this.value)
        this.$emit('input',  this.selectedItem)
      }  
    },
 
    checkItem(option, index){
      //Check if items have reached to 10
      if(index == this.max){
        this.itemCount = this.max
      }
      //Check if item is selected
      if(_.find(this.selectedItem, option)){
        return true
      } else{
        return false
      }
    },
   
    selectItem (option) {
      if(_.find(this.selectedItem, option)){
        this.selectedItem = _.reject(this.selectedItem, option)
      }else{
        this.selectedItem.push(option)
      }
      this.$emit('input',  this.selectedItem)
      // Clear search results
      this.search = ''
    },
 
    removeItem(index){
      this.hideList()
      this.selectedItem.splice(index, 1)
    },
 
    clearAll(){
      this.hideList()
      this.selectedItem.splice(0)
    },
 
    createUID () {
      return Math.floor(Math.random() * 100)
    },
 
    hideList(){
      let element = document.getElementById(this.uID)
      element.setAttribute("open", false)
    }
  },
}
</script>
 
<style lang="scss" scoped>
  .dtt-select {
    display: inline-flex;
    align-items: center;
  }
 
  // Select Field
  details {
    position: relative;
    margin-right: 1rem;
  }
 
  details[open] {
    z-index: 10;
  }
 
  .select-field{
    display: flex;
    align-items: center;
    padding-right:1rem;
    max-height:max-content;
    flex-wrap: wrap;
  }
 
  summary {
    width: auto;
    height: max-content;
    min-width: 400px;
    min-height: 40px;
    padding-top: .1rem;
    padding-bottom: .1rem;
    padding-left: .5rem;
    padding-right: .75rem;
    cursor: pointer;
    border-radius: 3px;
    border: 1px solid var(--gray-300);;
    background-color: #ffffff;
    list-style: none;
    .__placeholder {
      color: var(--gray-400);
      pointer-events: none;
    }
    .__selected {
      pointer-events: none;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
 
  .addLabel{
    margin-top: 1.5rem;
  }
 
  .addDesc{
    margin-bottom: 1.5rem;
  }
 
  summary::-webkit-details-marker {
    display: none;
  }
 
  details[open] summary {
    border: 1px solid var(--primary);
    transition: border-color 0.5s ease;
  }
 
  details[open] summary:before {
    content: '';
    display: block;
    width: 100vw;
    height: 100vh;
    background: transparent;
    position: fixed;
    top: 0;
    left: 0;
  }
 
  summary:after {
    content: '';
    display: inline-block;
    float: right;
    min-width: .65rem;
    min-height: .65rem;
    margin-bottom: 4px;
    margin-left: 1rem;
    color: var(--gray-400);
    border-bottom: 2px solid currentColor;
    border-left: 2px solid currentColor;
    border-bottom-left-radius: 2px;
    transform: rotate(-45deg);
    transition: 0.2s;
  }
 
  summary:focus {
    outline: none;
  }
 
  details[open] summary:after {
    transform: rotate(134deg);
    margin-top: 4px;
    margin-bottom: 0;
  }
 
  .select-label{
    position: absolute;
    left: 0px;
    top: -3px;
    font-size: 14px;
    color: var(--gray-700);
  }
 
  .select-description{
    position: absolute;
    left: 0px;
    bottom: 0px;
    color: var(--gray-500);
  }
 
  .clear-icon{
    position: absolute;
    right: 33px;
    font-size: 17px;
    color: var(--gray-400);
    z-index: 9;
    cursor: pointer;
  }
 
  .clear-icon:hover{
    color: var(--danger);
  }
 
 
  // Dropdown List
  .list {
    width: 100%;
    height: max-content;
    background: #fff;
    position: absolute;
    top: calc(100% + -1.5rem);
    left: 0;
    margin: 0;
    box-sizing: border-box;
    border-radius: 3px;
    padding-top: .25rem;
    padding-right: .2rem;
    box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.15), 0px 0px 2px rgba(0, 0, 0, 0.15), 0px 0px 1px rgba(0, 0, 0, 0.15);
    .__item {
      font-size: 14px;
      padding: .5rem 1rem;
      cursor: pointer;
      &:hover {
        background-color: var(--gray-100);
      }
    }
    .__no-records {
      padding: .5rem .75rem;
      text-align: center;
      color: var(--gray-400);
    }
    .search-field {
      margin-left: 0.25rem;
      padding: .75rem;
    }
  }
 
  .item-list{
    max-height: max-content;
    overflow-y: auto;
  }
 
  .item-list::-webkit-scrollbar {
    width: 6px;
  }
 
  .item-list::-webkit-scrollbar-track {
    background: transparent;
  }
 
  .item-list::-webkit-scrollbar-thumb {
    background: var(--gray-300);
    border-radius: 50px;
  }
 
  // Fake Select
  summary.radios {
    counter-reset: radios;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
 
  input[type=radio] {
    counter-increment: radios;
    appearance: none;
    display: none;
  }
 
  input[type=radio]:checked {
    display: inline;
    width: 88%;
  }
 
  input[type=radio]:after {
    content: attr(title);
    display: inline;
    font-size: 14px;
  }
 
  ul.list {
    counter-reset: labels;
  }
 
  label {
    width: 100%;
    display: block;
    cursor: pointer;
  }
 
  .__item{
    position: relative;
    display: flex;
    align-items: center;
  }
 
  // Checkmark Indicator
  .selected-indicator{
    align-self: center;
    margin-left: auto;
    color: var(--primary);
  }
 
  // Tags
  .select-tag{
    background-color: var(--gray-100);;
    padding: 0.3rem 0.5rem;
    margin-top: 0.2rem;
    margin-right: 0.35rem;
    margin-bottom: 0.2rem;
    display: flex;
    border-radius: 3px;
    width:max-content;
  }
 
  .select-tag:hover{
    background-color: var(--gray-200);;
    cursor: pointer;
  }
 
  .remove-option{
    margin-left: 0.5rem;
    color: var(--gray-500);;
    align-self: center;
  }
 
  .remove-option:hover{
    color: var(--danger);;
  }
 
  // Dropdown Search Field
  .search-field{
    position: relative;
  }
 
  .search-icon{
    position: absolute;
    top: 22px;
    left: 20px;
    font-size: 15px;
    color: var(--gray-500);;
  }
 
  .search-bar{
    width: 100%;
    height: 32px;
    border-radius: 3px;
    border: 1px solid var(--gray-400);;
    padding: 15px 29px;
  }
 
  .search-bar::placeholder {
    color: var(--gray-400);;
  }
  .search-bar:focus {    
    outline: none;
  }
</style>